import { ConversationChannel } from "@/types/channels";
import { computed, ref } from "vue";

const selectedChannel = ref<ConversationChannel>();

export function useChannelSelector() {
  const setChannel = (channel?: ConversationChannel) => {
    selectedChannel.value = channel;
  };

  return {
    setChannel,
    hasSelectedChannel: computed(() => !!selectedChannel.value),
    selectedChannel: computed(() => selectedChannel.value),
  };
}
